import { zOfferListForResidenceData } from '@repo/sdk/zod'
import { Alert, AlertDescription, AlertTitle } from '@repo/ui/alert'
import { Skeleton } from '@repo/ui/skeleton'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from '@/lib/i18n'
import { WhenWritable } from '../../-components/when-writable'
import { LaunchPanel } from './-components/launch-panel'
import { OffersList } from './-components/offers-list'
import { offerPreviewQueryOptions } from './-query/query-options'

const searchSchema = z.object({
	state: zOfferListForResidenceData.shape.body.shape.data.shape.state,
	page: z.number().int().min(1).default(1)
})

export const Route = createFileRoute('/(private)/bando/$residenceId/offerte/')({
	component: OffersPage,
	validateSearch: searchSchema,
	search: {
		middlewares: [stripSearchParams(searchSchema.parse({}))]
	}
})

/**
 * The offers of the residence (FFD 2.9): before the start, who gets one, with
 * which text and when, and the start itself; after it, every offer with its
 * state, its term and the last answer.
 */
function OffersPage() {
	const { t } = useTranslation()
	const { residenceId } = Route.useParams()
	const preview = useQuery(offerPreviewQueryOptions(residenceId))

	if (preview.isLoading) {
		return (
			<div className='flex flex-col gap-4 p-4 md:p-6'>
				<Skeleton className='h-24 w-full' />
				<Skeleton className='h-48 w-full' />
			</div>
		)
	}
	if (preview.isError || !preview.data) {
		return (
			<div className='p-4 md:p-6'>
				<Alert variant='destructive'>
					<AlertTitle>{t('admin-offers:page_title')}</AlertTitle>
					<AlertDescription>
						{t('admin-offers:errors.default')}
					</AlertDescription>
				</Alert>
			</div>
		)
	}
	if (preview.data.launchedAt) {
		return <OffersList residenceId={residenceId} />
	}
	return (
		<div className='mx-auto flex w-full max-w-6xl flex-col gap-6 p-4 md:p-6'>
			<WhenWritable>
				<LaunchPanel preview={preview.data} residenceId={residenceId} />
			</WhenWritable>
		</div>
	)
}
